import './Icon.css';
export const Icon = (props) => {
    return (
        <div className={`Icon ${props.i} ${props.onClick ? 'clickable' : ''}`} onClick={props.onClick}>
            <i className={`fas fa-${props.i}`}></i>
        </div>
    )
}